import {useEventSummaryPolling} from '../../redux/app/hooks/useEventSummaryPolling';

export const EventSummaryPolling = () => {
  useEventSummaryPolling();
  return null;
};
